import React, { Component } from 'react'
import { func, shape, number } from 'prop-types'
import { translate } from 'react-i18next'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { ByCard } from './ByCard'
import { ByWallet } from './ByWallet'
import { stores, view } from '../../stores'
import { Loader } from '../ui/states/Loader'
import { getUrlParam } from '../../utilities/url'
import { withRouter } from 'react-router'

class PaymentComponent extends Component {
  constructor () {
    super()
    this.state = { tab: 0, isWalletFed: false }
  }

  async componentDidMount () {
    await stores.account.getWallet()
    if (this.isWalletJustFed(this.props.location.search)) {
      this.setState({isWalletJustFed: true})
      this.openOtherPaymentsTab()
    }
  }
  openOtherPaymentsTab () { this.setState({tab: 1}) }

  isWalletJustFed (search) {
    const selectedPurchase = 'selectedPurchase'
    return !!getUrlParam(search, selectedPurchase)
  }

  render () {
    const { payment, t } = this.props
    const { loading, iban } = stores.account.wallet
    const { token } = stores.authentication
    return (
      <div className='paiement' >
        <Tabs onSelect={(i) => this.setState({ tab: i })} selectedIndex={this.state.tab} >
          <TabList className='paiement__header'>
            <Tab className='paiement__header__item'>{t('common:payment:payment_tab1')}</Tab>
            <Tab className='paiement__header__item'>{t('common:payment:payment_others')}</Tab>
          </TabList>

          <TabPanel className='paiement__body' >
            <ByCard payment={payment} />
          </TabPanel>
          <TabPanel className='paiement__body'>
            {
              loading
              ? <Loader size='medium' message={t('common:payment:refreshing_wallet')} />
              : <ByWallet payment={payment} iban={iban} asAdmin={token.asAdmin} isWalletJustFed={this.state.isWalletJustFed} />
            }
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

PaymentComponent.propTypes = {
  t: func,
  payment: shape({
    advance: number,
    unpaid: number,
    total: number,
    balance: number
  })
}

export const Payment = withRouter(translate()(view(PaymentComponent)))



// WEBPACK FOOTER //
// ./src/components/payment/Payment.js